import axios from 'api/axios'

const baseChat = (codigo, origen) => `solicitud/chat/${codigo}/${origen}/`
const baseChats = (codigo, origen) => `solicitud/chats/${codigo}/${origen}/`
const baseMarcarLeidos = (codigo, origen) => `solicitud/chats/${codigo}/${origen}/marcar-leidos/`
const NO_LEIDOS = 'solicitud/chats/no-leidos/'

export const listarMensajes = (codigo, origen) =>
  axios.get(baseChats(codigo, origen)).then((r) => r.data)

export const enviarMensaje = (codigo, origen, mensaje, fichero = null) => {
  if (fichero) {
    const form = new FormData()
    form.append('mensaje', mensaje || '')
    form.append('fecha', new Date().toISOString())
    form.append('fichero', fichero)
    return axios
      .post(baseChat(codigo, origen), form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data)
  }
  return axios
    .post(baseChat(codigo, origen), {
      mensaje: mensaje || '',
      fecha: new Date().toISOString(),
    })
    .then((r) => r.data)
}

export const marcarLeidos = (codigo, origen, chatIds) =>
  axios.post(baseMarcarLeidos(codigo, origen), { chat_ids: chatIds }).then((r) => r.data)

export const contarNoLeidos = (pares) => {
  if (!pares || pares.length === 0) {
    return Promise.resolve([])
  }
  const codigos = pares.map((p) => p.codigo).join(',')
  const origenes = pares.map((p) => p.origen).join(',')
  return axios.get(NO_LEIDOS, { params: { codigos, origenes } }).then((r) => r.data)
}
